import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RunnerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RunnerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.0406 20.6873L16.0505 16.6982C16.0066 16.5214 15.9152 16.36 15.7862 16.2313L14.6707 15.118C14.4827 14.9304 14.3771 14.6758 14.3771 14.4102V8.0633C14.3771 7.23487 13.7055 6.5633 12.8771 6.5633H12.1813C11.5378 6.5633 10.9924 6.97248 10.7798 7.54279C10.7609 7.5832 10.7535 7.62726 10.74 7.67048C10.7231 7.73237 10.7107 7.79511 10.7018 7.85993C10.6981 7.89509 10.6813 7.9256 10.6813 7.96174V13.1326C10.6813 13.6638 10.8925 14.1732 11.2684 14.5484L12.6705 15.9481L12.6724 15.9493L14.1764 17.45L15.0992 21.1698C15.2125 21.6248 15.6202 21.9285 16.069 21.9285C16.149 21.9285 16.2301 21.9188 16.3107 21.8992C16.8468 21.7664 17.1734 21.2235 17.0406 20.6873Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.49083 14.0486C8.44737 14.0486 8.40392 14.0457 8.35997 14.0399C7.81212 13.9686 7.42638 13.4666 7.49767 12.9188L7.94689 9.47834C7.98449 9.19123 8.14562 8.93342 8.38781 8.77326L11.3175 6.84064C11.7799 6.53888 12.399 6.66486 12.7032 7.12482C13.007 7.58576 12.88 8.20587 12.4191 8.51056L9.87121 10.1912L9.48107 13.1785C9.41515 13.6814 8.98545 14.0486 8.49083 14.0486Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.258 5.89002C14.3321 5.89002 15.203 5.01921 15.203 3.94501C15.203 2.87081 14.3321 2 13.258 2C12.1838 2 11.3129 2.87081 11.3129 3.94501C11.3129 5.01921 12.1838 5.89002 13.258 5.89002Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2733 9.81354C17.1244 9.28131 16.5687 8.97077 16.0409 9.12018L15.2065 9.35382C15.0608 10.3079 14.7947 11.1092 14.5997 11.6004L16.5799 11.046C17.1117 10.8975 17.4222 10.3448 17.2733 9.81354Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.0357 15.4999L9.97472 17.2855L7.65761 18.1474C7.13857 18.3368 6.87148 18.911 7.06093 19.4296C7.20937 19.8358 7.59218 20.0868 8.00038 20.0868C8.11415 20.0868 8.23036 20.0673 8.34315 20.0263L10.9903 19.0443C11.2042 18.9662 11.3844 18.8177 11.5025 18.6234L12.4928 16.9539L11.0357 15.4999Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RunnerIcon;
